<template>
  <a :href="href" :target="target" class="k-link">
    {{ text }}<i v-if="faIcon" :class="iconClass"></i>
  </a>
</template>

<style scoped>
a > i {
  margin-left: 0.2em;
  font-size: 1.1em;
  vertical-align: middle;
}
</style>

<script>
export default {
  props: {
    href: {
      type: String,
    },
    text: {
      type: String,
    },
    target: {
      type: String,
      default: '_blank',
    },
    faIcon: {
      type: String,
      default: 'fa-external-link-alt',
    },
  },
  computed: {
    iconClass() {
      return this.faIcon ? `fas ${this.faIcon}` : '';
    },
  },
};
</script>
